import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  user: any;
  role: RoleType | null | undefined;
  token: string | null | undefined;
  uid: string | null | undefined;
  activeProgramId: string | null | undefined; 
}

const initialState: AuthState = {
  user: null,
  role: null,
  token: null,
  uid: null,
  activeProgramId: null, 
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUID: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
    },
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    setRole: (state, action: PayloadAction<RoleType>) => {
      state.role = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setActiveProgramId: (state, action: PayloadAction<string>) => {
      state.activeProgramId = action.payload; 
    },
    setAllAuth: (state, action: PayloadAction<any>) => {
      state.uid = action.payload.uid;
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.token = action.payload.token;
      state.activeProgramId = action.payload.activeProgramId || null; 
    },
    defaultState: (state) => {
      console.log("reset");
      return initialState; 
    },
  },
});

export const {
  setUser,
  setRole,
  setToken,
  defaultState,
  setUID,
  setAllAuth,
  setActiveProgramId,
} = authSlice.actions;

export default authSlice.reducer;
